import Button from 'antd/es/button';
import { Space } from 'antd';

import { GraphinContext, GraphinContextType, NodeConfig } from '@antv/graphin';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useContext } from 'react';

export const GraphZoomButtons: React.FC = () => {
	const { graph } = useContext<GraphinContextType>(GraphinContext);

	const handleOnZoomIn = () => {
		const app = graph.findById('app');
		const salesforce = graph.findById('salesforce');
		const center = app || salesforce;

		const centerModel = center?.getModel() as NodeConfig;

		const zoom = graph.getZoom() || 1;
		graph.zoomTo(zoom + 0.25,
			{
				x: centerModel?.x ?? 0,
				y: centerModel?.y ?? 0
			},
			true);
	};

	const handleOnZoomOut = () => {
		const app = graph.findById('app');
		const salesforce = graph.findById('salesforce');
		const center = app || salesforce;

		const centerModel = center?.getModel() as NodeConfig;

		const zoom = graph.getZoom() || 1;
		graph.zoomTo(zoom - 0.25,
			{
				x: centerModel?.x ?? 0,
				y: centerModel?.y ?? 0
			},
			true);
	};

	return (
		<Space
			direction='horizontal'
			size={ 4 }>
			<Button
				icon={ <PlusOutlined /> }
				id='zoom-in-button'
				onClick={ handleOnZoomIn } />
			<Button
				icon={ <MinusOutlined /> }
				id='zoom-out-button'
				onClick={ handleOnZoomOut } />
		</Space>);
};
